module.exports = __webpack_public_path__ + "static/media/gameVendingMachine.c97f9892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameVendingMachine.png
// module id = 2579
// module chunks = 0